/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';

import { getParentCacheKey } from './helpers/getParentCacheKey';

export const listByParentId = createAsyncThunk(
  'productCategories/listByParentId',
  async ({ parentId } = {}, { extra: { sdk, Logger } }) => {
    try {
      const { data } = await sdk.productCategories.list(
        parentId ? { parentId } : {},
      );
      return {
        parentId: getParentCacheKey(parentId),
        categories: data || [],
      };
    } catch (error) {
      Logger.error(new Error('Error product categories fetching'), { error }, [
        'ListProductCategoriesFailed',
        { errorMessage: 'Product categories can not be fetched from backend.' },
      ]);
      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder
    .addCase(listByParentId.pending, (state, { meta }) => {
      const cacheKey = getParentCacheKey(meta.arg?.parentId);
      state.loadingByParentId[cacheKey] = true;
      delete state.errorByParentId[cacheKey];
    })
    .addCase(listByParentId.fulfilled, (state, { payload }) => {
      const { parentId, categories } = payload;
      state.childrenByParentId[parentId] = categories;
      state.loadingByParentId[parentId] = false;
      delete state.errorByParentId[parentId];
    })
    .addCase(listByParentId.rejected, (state, { meta }) => {
      const cacheKey = getParentCacheKey(meta.arg?.parentId);
      state.loadingByParentId[cacheKey] = false;
      state.errorByParentId[cacheKey] = true;
    });
};
